// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables() {
  
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_currentAccountV5_marketingProfile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AgentMarketingProfile"]);
}

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"currentAccountV5_marketingProfile_AgentMarketingProfile":{"f":""},"currentAccountV5_marketingProfile":{"u":"response_currentAccountV5_marketingProfile"}}};

var wrapResponseConverterMap = {
  response_currentAccountV5_marketingProfile: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"currentAccountV5_marketingProfile_AgentMarketingProfile":{"f":""},"currentAccountV5_marketingProfile":{"u":"response_currentAccountV5_marketingProfile"}}};

var responseConverterMap = {
  response_currentAccountV5_marketingProfile: unwrap_response_currentAccountV5_marketingProfile
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentMarketingProfileSlugFormQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "AccountV5",
          "kind": "LinkedField",
          "name": "currentAccountV5",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AgentMarketingProfileSlugForm_form_agentMarketingProfile"
                      }
                    ],
                    "type": "AgentMarketingProfile",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AgentMarketingProfileSlugFormQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountV5",
        "kind": "LinkedField",
        "name": "currentAccountV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "marketingProfile",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MarketingProfileURLDetails",
                    "kind": "LinkedField",
                    "name": "urlDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "baseUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AgentMarketingProfile",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e561ff3bf3d14f95f0e62035b2ee44e8",
    "id": null,
    "metadata": {},
    "name": "AgentMarketingProfileSlugFormQuery",
    "operationKind": "query",
    "text": "query AgentMarketingProfileSlugFormQuery {\n  currentAccountV5 {\n    marketingProfile {\n      __typename\n      ... on AgentMarketingProfile {\n        ...AgentMarketingProfileSlugForm_form_agentMarketingProfile\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n\nfragment AgentMarketingProfileSlugForm_form_agentMarketingProfile on AgentMarketingProfile {\n  publicUrl\n  urlDetails {\n    baseUrl\n    slug\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

var wrap_response_currentAccountV5_marketingProfile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_currentAccountV5_marketingProfile = unwrap_response_currentAccountV5_marketingProfile;
exports.wrap_response_currentAccountV5_marketingProfile = wrap_response_currentAccountV5_marketingProfile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
